// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"b6caaf7dc1a7087ac081","655":"19db1a22ed09702c8eb3"}[chunkId] + ".js";
};